import { Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { DecimalControl } from '../../../controls/setup-wizard/decimal-control/decimal-control';

@Component({
	selector: 'app-decimal-field',
	standalone: true,
	templateUrl: './decimal-field.html',
	styleUrl: './decimal-field.scss',
	imports: [DecimalControl],
})
export class DecimalField {
	label = input.required<string>();
	controlName = input.required<string>();
	placeholder = input<string>('');
	required = input<boolean>(true);
	min = input<number | null>(null);
	max = input<number | null>(null);
	formGroup = input.required<FormGroup>();
	disabled = input<boolean>(false);
}
